module.exports = __webpack_public_path__ + "img/blue.58b2226d.png";